import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { env } from "@/env";

const inputSchema = z.object({
	name: z.string().min(1),
	email: z.string().email(),
	phone: z.string().optional(),
	hotel: z.string().optional(),
	message: z.string().min(1),
});

export const submitContact = createServerFn({ method: "POST" })
	.inputValidator(inputSchema)
	.handler(async ({ data }) => {
		const writeToken = env.STRAPI_WRITE_TOKEN;
		const baseUrl = env.VITE_STRAPI_BASE_URL;

		const res = await fetch(`${baseUrl}/api/contact-messages`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${writeToken}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ data }),
		});

		if (!res.ok) {
			throw new Error("Contact submission failed");
		}

		return { success: true };
	});
